"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _searchRequest = require("../utils/search-request.utils");
var _search = require("../utils/search.utils");
function searchRequestFactory(query, requestPayload) {
  var _requestPayload$ticke;
  var pax = (0, _search.getPaxFromQuery)(query);
  var leg = (0, _search.getRequestLegFromQuery)(query);
  var requestAirports = (0, _searchRequest.getRequestAirports)(leg);
  var _getParamsFromQuery = (0, _search.getParamsFromQuery)(query),
    originId = _getParamsFromQuery.originId,
    destinationId = _getParamsFromQuery.destinationId,
    departureDate = _getParamsFromQuery.departureDate,
    returnDate = _getParamsFromQuery.returnDate,
    flexibleDate = _getParamsFromQuery.flexibleDate;
  return {
    query: query,
    originId: originId,
    destinationId: destinationId,
    departureDate: departureDate,
    returnDate: returnDate,
    searchType: (0, _search.getSearchTypeFromQuery)(query),
    totalDays: (0, _searchRequest.getRequestTripTotalDays)(leg),
    preferredCabin: (0, _search.getCabinTypeFromQuery)(query),
    isRoundTrip: (0, _search.checkRoundTrip)(query),
    isDomestic: (0, _search.checkDomestic)(query),
    isDomesticKSA: (0, _search.checkDomesticKSA)(query),
    isMultiCity: (0, _search.checkMultiCity)(query),
    isOneWay: (0, _search.checkOneWay)(query),
    ticketingType: (_requestPayload$ticke = requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.ticketingType) !== null && _requestPayload$ticke !== void 0 ? _requestPayload$ticke : '',
    pax: pax,
    paxList: (0, _searchRequest.getRequestPaxList)(pax),
    totalPax: (0, _searchRequest.getRequestTotalPax)(pax),
    leg: leg,
    goingLeg: leg[0],
    comingLeg: leg[1],
    firstOrigin: (0, _get2.default)(leg, '[0].originId', ''),
    lastDestination: (0, _get2.default)((0, _last2.default)(leg), 'destinationId', ''),
    requestAirports: requestAirports,
    requestAirportsFilterQuery: (0, _searchRequest.getRequestAirportsFilterQuery)(requestAirports),
    flexibleDate: flexibleDate
  };
}
var _default = exports.default = searchRequestFactory;